<template>
    <div class="data-dashboard">
        <header class="dashboard-header">
            <div class="p-left">
                <dv-decoration-3 style="width:250px;height:30px;" />
            </div>
            <h1>大数据可视化平台</h1>
            <div class="time">
                <el-date-picker v-model="selectDate" type="date" placeholder="选择日期时间" @change="changeDate"
                    value-format="yyyy/MM/dd">
                </el-date-picker>
                <el-select v-model="selectDateType" placeholder="请选择" @change="changeType">
                    <el-option v-for="item in dateType" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </header>

        <main class="dashboard-body">
            <section class="dashboard-column">
                <dv-border-box-9>
                    <div class="panel1 chart-panel" style="border: none;">
                        <div class="data-display">
                            <!-- 今天的数据 -->
                            <div class="section">
                                <div class="label">总业务量</div>
                                <div class="number-group">
                                    <div v-for="(digit, index) in todayData" :key="index" class="digit"
                                        :class="{ 'animate': isAnimating && index === currentAnimateIndex }">
                                        {{ digit }}
                                    </div>
                                </div>
                            </div>

                            <!-- 昨天的数据 -->
                            <div class="section">
                                <div class="label">总散件量</div>
                                <div class="number-group">
                                    <div v-for="(digit, index) in yesterdayData" :key="index" class="digit"
                                        :class="{ 'animate': isAnimating && index === currentAnimateIndex }">
                                        {{ digit }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </dv-border-box-9>

                <!-- <dv-border-box-12 :color="['#298cc6']" backgroundColor="#000c55"> -->
                <div class="panel data-card" style="--row-span: 2">
                    <div class="title-box">
                        <div class="data-title">
                            签到率
                        </div>
                        <!-- <div class="check-more">
                            查看更多
                        </div> -->
                    </div>
                    <base-chart ref="checkIn" :options="checkInOption" height="calc(100% - 2.5rem)" />
                </div>
                <!-- </dv-border-box-12> -->

                <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                <!-- <div class="panel metric-card">
                    <div class="title-box">
                        <div class="data-title">
                            熟练度
                        </div>
                        <div class="check-more">
                            查看更多
                        </div>
                    </div>
                    <base-chart ref="lineChart" :options="proficientOption" height="calc(100% - 2.5rem)" />
                </div> -->
                <!-- </dv-border-box-12> -->
            </section>

            <section class="dashboard-column">
                <div class="main-chart">
                    <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                    <div class="panel">
                        <div class="title-box">
                            <div class="data-title">
                                各中心业务量
                            </div>
                            <!-- <div class="check-more">
                                查看更多
                            </div> -->
                        </div>
                        <base-chart ref="radarChart" :options="sycmOption" height="calc(100% - 2.5rem)" />
                    </div>
                    <!-- </dv-border-box-12> -->
                    <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                    <div class="panel">
                        <div class="title-box">
                            <div class="data-title">
                                T-1人效
                            </div>
                            <!-- <div class="check-more">
                                查看更多
                            </div> -->
                        </div>
                        <base-chart ref="radarChart" :options="barChartOptionsT" height="calc(100% - 2.5rem)" />
                    </div>
                    <!-- </dv-border-box-12> -->
                </div>
                <div class="main-chart-bottom" style="--row-span: 1">
                    <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                    <div class="panel">
                        <div class="title-box">
                            <div class="data-title">
                                性别分布
                            </div>
                            <!-- <div class="check-more">
                                查看更多
                            </div> -->
                        </div>
                        <base-chart ref="pieChart" :options="sexPieChart" height="calc(100% - 2.5rem)" />
                    </div>
                    <!-- </dv-border-box-12> -->
                    <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                    <div class="panel">
                        <div class="title-box">
                            <div class="data-title">
                                年龄分布
                            </div>
                            <!-- <div class="check-more">
                                查看更多
                            </div> -->
                        </div>
                        <base-chart ref="pieChart" :options="agePieChart" height="calc(100% - 2.5rem)" />
                    </div>
                    <!-- </dv-border-box-12> -->
                </div>
            </section>

            <section class="dashboard-column">
                <dv-border-box-7 :color="['#298cc6']">
                    <div class="panel1 metric-card">
                        <div class="title-box">
                            <div class="data-title">
                                数据指标
                            </div>
                            <!-- <div class="check-more">
                                查看更多
                            </div> -->
                        </div>
                        <div class="data-container">
                            <div class="data-item">
                                <div class="label">总用工人数</div>
                                <div class="value">{{ totaldata.total_staff_num }}</div>
                            </div>
                            <div class="data-item">
                                <div class="label">总人效</div>
                                <div class="value">{{ totaldata.total_humanefficiency }}</div>
                            </div>
                            <div class="data-item">
                                <div class="label">总签到率</div>
                                <div class="value">{{ totaldata.total_sign_rate }}</div>
                            </div>
                            <div class="data-item">
                                <div class="label">熟练度</div>
                                <div class="value">{{ totaldata.total_proficiency_rate }}</div>
                            </div>
                        </div>
                    </div>
                </dv-border-box-7>
                <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                <div class="panel">
                    <div class="title-box">
                        <div class="data-title">
                            中心损益分析
                        </div>
                        <!-- <div class="check-more">
                            查看更多
                        </div> -->
                    </div>
                    <dv-scroll-board :config="centerConfig" style="width:100%;height:calc(100% - 2.5rem)" />
                </div>
                <!-- </dv-border-box-12> -->
                <!-- <dv-border-box-12 :color="['#298cc6']"> -->
                <div class="panel data-card">
                    <div class="title-box">
                        <div class="data-title">
                            外包商损益分析
                        </div>
                        <!-- <div class="check-more">
                            查看更多
                        </div> -->
                    </div>
                    <dv-scroll-board :config="webConfig" style="width:100%;height:calc(100% - 2.5rem)" />
                </div>
                <!-- </dv-border-box-12> -->
            </section>
        </main>
    </div>
</template>

<script>
import api from "@/api/site.js"
import BaseChart from '@/components/BaseChart'

export default {
    components: {
        BaseChart
    },
    data() {
        return {
            site_id: "",
            selectDate: this.getFormattedDate(new Date()), // 选择的日期
            dateType: [{
                value: '0',
                label: '日'
            }, {
                value: '1',
                label: '月'
            }, {
                value: '2',
                label: '年'
            }],
            selectDateType: "0", // 选择的类型
            todayData: '10728011',
            yesterdayData: '08237886',
            isAnimating: false,
            currentAnimateIndex: -1,
            totaldata: "",
            currentTime: new Date().toLocaleString(),
            // 各中心业务量
            sycmOption: {
                loading: false,
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(50,50,50,0.7)',
                    borderColor: '#444'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                legend: {
                    data: '',
                    textStyle: {
                        color: '#fff',
                        fontSize: 12
                    },
                    right: '0'
                },
                toolbox: {
                    show: true,
                },
                xAxis: {
                    type: 'category',
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(100,100,100,0.2)'
                        }
                    }
                },
                dataZoom: [
                    {
                        type: 'slider', // 滑块型
                        show: true,
                        start: 0, // 初始显示区域起始位置（百分比）
                        end: 20, // 初始显示区域结束位置（百分比）
                        xAxisIndex: [0],
                        bottom: '10px', // 滑块位置
                        height: 25, // 滑块高度
                        handleSize: '80%', // 滑块手柄大小
                        handleStyle: {
                            color: '#3498db'
                        },
                        fillerColor: 'rgba(52, 152, 219, 0.2)', // 滑块选中区域颜色
                        borderColor: '#3498db'
                    },
                    {
                        type: 'inside', // 内置型，支持鼠标/触摸板交互
                        start: 0,
                        end: 20,
                        xAxisIndex: [0]
                    }
                ],
                series: [// 第一个数据系列：实际销售额
                    {
                        name: "",
                        data: "",
                        type: 'bar',
                        barWidth: '30%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff',
                            fontSize: 12
                        },
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#83bff6' },
                                { offset: 0.5, color: '#188df0' },
                                { offset: 1, color: '#188df0' }
                            ])
                        }
                    },
                    // 第二个数据系列：散件量
                    {
                        name: "",
                        data: "",
                        type: 'bar',
                        barWidth: '30%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff',
                            fontSize: 12
                        },
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#293fff' },
                                { offset: 0.5, color: '#188df0' },
                                { offset: 1, color: '#188df0' }
                            ])
                        }
                    }]
            },
            // T-1人效
            barChartOptionsT: {
                loading: true,
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(50,50,50,0.7)',
                    borderColor: '#444'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                toolbox: {
                    show: true,
                },
                dataZoom: [
                    {
                        type: 'slider', // 滑块型
                        show: true,
                        start: 0, // 初始显示区域起始位置（百分比）
                        end: 20, // 初始显示区域结束位置（百分比）
                        xAxisIndex: [0],
                        bottom: '10px', // 滑块位置
                        height: 25, // 滑块高度
                        handleSize: '80%', // 滑块手柄大小
                        handleStyle: {
                            color: '#3498db'
                        },
                        fillerColor: 'rgba(52, 152, 219, 0.2)', // 滑块选中区域颜色
                        borderColor: '#3498db'
                    },
                    {
                        type: 'inside', // 内置型，支持鼠标/触摸板交互
                        start: 0,
                        end: 20,
                        xAxisIndex: [0]
                    }
                ],
                // 添加图例，区分标准值和现有值
                legend: {
                    data: '',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10
                    },
                    right: '0'
                },
                xAxis: {
                    type: 'category',
                    data: [],
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(100,100,100,0.2)'
                        }
                    }
                },
                series: [{
                    data: [],
                    type: 'bar',
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#83bff6' },
                            { offset: 0.5, color: '#188df0' },
                            { offset: 1, color: '#188df0' }
                        ])
                    },
                    emphasis: {
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#2378f7' },
                                { offset: 0.7, color: '#2378f7' },
                                { offset: 1, color: '#83bff6' }
                            ])
                        }
                    },
                    markLine: {
                        data: [
                            [{ yAxis: 50 }]
                        ]
                    }
                }]
            },
            // 饼图配置 - 性别
            sexPieChart: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center',
                    textStyle: {
                        color: '#ccc'
                    },
                    data: ['男性', '女性']
                },
                series: [{
                    name: '产品类别',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ['40%', '50%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#0f0f33',
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '18',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                }]
            },
            // 饼图配置 - 年龄
            agePieChart: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center',
                    textStyle: {
                        color: '#ccc'
                    },
                    data: ['<40岁', '40-50岁', '50-55岁', '>55岁']
                },
                series: [{
                    name: '年龄分布',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ['40%', '50%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#0f0f33',
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '18',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                }]
            },
            // 折线图配置 - 签到率
            checkInOption: {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{a}: {c}%<br />{b1}: {c1}%'
                },
                legend: {
                    textStyle: {
                        color: '#ccc'
                    },
                    data: ['标准值', '现有值']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                toolbox: {
                    show: true,
                },
                dataZoom: [
                    {
                        type: 'slider', // 滑块型
                        show: true,
                        start: 0, // 初始显示区域起始位置（百分比）
                        end: 20, // 初始显示区域结束位置（百分比）
                        xAxisIndex: [0],
                        bottom: '10px', // 滑块位置
                        height: 25, // 滑块高度
                        handleSize: '80%',
                        handleStyle: {
                            color: '#3498db'
                        },
                        fillerColor: 'rgba(52, 152, 219, 0.2)', // 滑块选中区域颜色
                        borderColor: '#3498db'
                    },
                    {
                        type: 'inside', // 内置型，支持鼠标/触摸板交互
                        start: 0,
                        end: 20,
                        xAxisIndex: [0]
                    }
                ],
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: [],
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(100,100,100,0.2)'
                        }
                    },
                    axisLabel: {
                        formatter: '{value}%',
                        color: '#fff'
                    }
                },
                series: [{
                    name: '标准值',
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                        width: 4,
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            { offset: 0, color: '#2ec7c9' },
                            { offset: 1, color: '#81cff2' }
                        ])
                    },
                    areaStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(46,199,201,0.5)' },
                            { offset: 1, color: 'rgba(46,199,201,0.1)' }
                        ])
                    },
                    data: []
                }, {
                    name: "现有值",
                    data: [],
                    type: 'bar',
                    barWidth: '30%',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#fff',
                        fontSize: 12,
                        formatter: '{c}%'
                    },
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#293fff' },
                            { offset: 0.5, color: '#188df0' },
                            { offset: 1, color: '#188df0' }
                        ])
                    }
                }]
            },
            // 熟练度
            proficientOption: {
                tooltip: {
                    trigger: 'axis',
                    formatter: '{a}: {c}%<br />{b1}: {c1}%'
                },
                legend: {
                    textStyle: {
                        color: '#ccc'
                    },
                    data: ['标准值', '现有值']
                },
                toolbox: {
                    show: true,
                },
                dataZoom: [
                    {
                        type: 'slider', // 滑块型
                        show: true,
                        start: 0, // 初始显示区域起始位置（百分比）
                        end: 20, // 初始显示区域结束位置（百分比）
                        xAxisIndex: [0],
                        bottom: '10px', // 滑块位置
                        height: 25, // 滑块高度
                        handleSize: '80%', // 滑块手柄大小
                        handleStyle: {
                            color: '#3498db'
                        },
                        fillerColor: 'rgba(52, 152, 219, 0.2)', // 滑块选中区域颜色
                        borderColor: '#3498db'
                    },
                    {
                        type: 'inside', // 内置型，支持鼠标/触摸板交互
                        start: 0,
                        end: 20,
                        xAxisIndex: [0]
                    }
                ],
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: [],
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#666'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(100,100,100,0.2)'
                        }
                    },
                    axisLabel: {
                        formatter: '{value}%',
                        color: '#fff'
                    }
                },
                series: [{
                    name: '标准值',
                    type: 'line',
                    smooth: true,
                    lineStyle: {
                        width: 4,
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                            { offset: 0, color: '#2ec7c9' },
                            { offset: 1, color: '#81cff2' }
                        ])
                    },
                    areaStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(46,199,201,0.5)' },
                            { offset: 1, color: 'rgba(46,199,201,0.1)' }
                        ])
                    },
                    data: []
                }, {
                    name: "现有值",
                    data: [],
                    type: 'bar',
                    barWidth: '30%',
                    label: {
                        show: true,
                        position: 'top',
                        color: '#fff',
                        fontSize: 12,
                        formatter: '{c}%'
                    },
                    itemStyle: {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#293fff' },
                            { offset: 0.5, color: '#188df0' },
                            { offset: 1, color: '#188df0' }
                        ])
                    }
                }]
            },
            // 中心
            centerConfig: {
            },
            webConfig: {
            }
        }
    },
    created() {
        this.getQueryParamsWithURLSearchParams(); // 获取地址栏传参
        this.fetchData();
        this.userdistribution();
        this.businessvolume();
        this.humanefficiency();
        this.signrate();
        // this.proficiencyrate();
        this.centerloss();
        this.outsourcingloss();
    },
    mounted() {
        // 每秒更新时间
        setInterval(() => {
            this.currentTime = new Date().toLocaleString()
        }, 1000)

        this.loadData()

        // 注册全局事件，用于更新所有图表
        // this.$bus = new Vue()
        // this.$bus.$on('refresh-charts', this.loadData)

        // 监听窗口大小变化
        window.addEventListener('resize', this.handleWindowResize);


    },
    methods: {
        getQueryParamsWithURLSearchParams() {
            try {
                // 创建 URLSearchParams 对象
                const urlParams = new URLSearchParams(window.location.search);

                // 转换为对象
                const params = {};
                for (const [key, value] of urlParams.entries()) {
                    params[key] = value;
                }

                this.queryParams = params;
                console.log('URLSearchParams 方式:', this.queryParams);
                this.site_id = this.queryParams.site_id;
            } catch (error) {
                console.error('解析URL参数失败:', error);
                this.queryParams = {};
            }
        },
        handleWindowResize() {
            if (this.$refs.barChart) this.$refs.barChart.resize()
            if (this.$refs.pieChart) this.$refs.pieChart.resize()
            if (this.$refs.lineChart) this.$refs.lineChart.resize()
            if (this.$refs.radarChart) this.$refs.radarChart.resize()
        },
        getFormattedDate(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}/${month}/${day}`;
        },
        changeDate(e) {
            console.log("选择日期", e);
            this.fetchData();
            this.userdistribution();
            this.businessvolume();
            this.humanefficiency();
            this.signrate();
            // this.proficiencyrate();
            this.centerloss();
            this.outsourcingloss();
        },
        changeType(e) {
            console.log("切换类型", e);
            this.fetchData();
            this.userdistribution();
            this.businessvolume();
            this.humanefficiency();
            this.signrate();
            // this.proficiencyrate();
            this.centerloss();
            this.outsourcingloss();
        },
        fetchData() {
            api.totalmanagement({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                this.totaldata = res.data;
                this.todayData = this.totaldata.total_business_volume.toString().split('').map(Number);
                this.yesterdayData = this.totaldata.total_bulk_quantity.toString().split('').map(Number);
                // this.updateData('10728012', '08237887');
            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        updateData(newToday, newYesterday) {
            this.isAnimating = true;
            this.currentAnimateIndex = 0;

            // 更新每个数字
            const updateNextDigit = () => {
                if (this.currentAnimateIndex >= Math.max(this.todayData.length, this.yesterdayData.length)) {
                    this.isAnimating = false;
                    return;
                }

                // 更新今天的数字
                if (this.currentAnimateIndex < this.todayData.length) {
                    this.todayData = this.todayData.substring(0, this.currentAnimateIndex) +
                        newToday[this.currentAnimateIndex] +
                        this.todayData.substring(this.currentAnimateIndex + 1);
                }

                // 更新昨天的数字
                if (this.currentAnimateIndex < this.yesterdayData.length) {
                    this.yesterdayData = this.yesterdayData.substring(0, this.currentAnimateIndex) +
                        newYesterday[this.currentAnimateIndex] +
                        this.yesterdayData.substring(this.currentAnimateIndex + 1);
                }

                this.currentAnimateIndex++;
                setTimeout(updateNextDigit, 100); // 调整时间以控制动画速度
            };

            updateNextDigit();

            console.log("用来渲染的数据", this.todayData);
        },
        // 用户分布
        userdistribution() {
            api.userdistribution({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                let data = res.data;
                // 更新饼图数据
                this.sexPieChart.series[0].data = [{
                    value: data.female,
                    name: '男性',
                },
                {
                    value: data.male,
                    name: '女性',
                }
                ]

                this.sexPieChart.series[0].data = [{
                    value: data.female,
                    name: '男性',
                },
                {
                    value: data.male,
                    name: '女性',
                }
                ]

                this.agePieChart.series[0].data = [{
                    value: data.g,
                    name: '<40岁',
                    itemStyle: {
                        color: '#52c41a'
                    }
                },
                {
                    value: data.z,
                    name: '40-50岁',
                    itemStyle: {
                        color: '#faad14'
                    }
                },
                {
                    value: data.b,
                    name: '50-55岁',
                    itemStyle: {
                        color: '#1890ff'
                    }
                },
                {
                    value: data.w,
                    name: '>55岁',
                    itemStyle: {
                        color: '#f5222d'
                    }
                }
                ]

            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        businessvolume() {
            api.businessvolume({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                let data = res.data;
                let legend = data.y.map(item => item.name);
                this.sycmOption.legend.data = legend;
                this.sycmOption.xAxis.data = data.x;

                this.sycmOption.series[0].data = data.y[0].data;
                this.sycmOption.series[0].name = data.y[0].name;

                this.sycmOption.series[1].data = data.y[1].data;
                this.sycmOption.series[1].name = data.y[1].name;

            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        // T-1人效
        humanefficiency() {
            api.humanefficiency({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                console.log("T-1人效", res);


                let data = res.data;
                let legend = data.y.map(item => item.name);
                this.barChartOptionsT.legend.data = legend;
                this.barChartOptionsT.xAxis.data = data.x;

                this.barChartOptionsT.series = [
                    // 第一个数据系列：标准值
                    {
                        name: '标准值',
                        type: 'line',
                        smooth: true,
                        lineStyle: {
                            width: 4,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: '#2ec7c9' },
                                { offset: 1, color: '#81cff2' }
                            ])
                        },
                        areaStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(46,199,201,0.5)' },
                                { offset: 1, color: 'rgba(46,199,201,0.1)' }
                            ])
                        },
                        data: data.y[0].data,
                    },
                    // 第二个数据系列：现有值
                    {
                        name: '现有值',
                        type: 'bar',
                        data: data.y[1].data,
                        barWidth: '30%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff',
                            fontSize: 12
                        },
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#293fff' },
                                { offset: 0.5, color: '#188df0' },
                                { offset: 1, color: '#188df0' }
                            ])
                        }
                    }
                ];
            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        // 签到率
        signrate() {
            api.signrate({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                console.log("签到率", res);
                let data = res.data;
                let legend = data.y.map(item => item.name);
                this.checkInOption.xAxis.data = data.x;
                this.checkInOption.series[0].data = data.y[0].data;
                this.checkInOption.series[0].name = data.y[0].name;
                this.checkInOption.series[1].data = data.y[1].data;
                this.checkInOption.series[1].name = data.y[1].name;

            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        proficiencyrate() {
            api.proficiencyrate({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                console.log("签到率", res);
                let data = res.data;
                this.proficientOption.xAxis.data = data.x;
                this.proficientOption.series[0].data = data.y[0].data;
                this.proficientOption.series[0].name = data.y[0].name;
                this.proficientOption.series[1].data = data.y[1].data;
                this.proficientOption.series[1].name = data.y[1].name;

            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        // 中心损益分析
        centerloss() {
            api.centerloss({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                let data = res.data;
                let dataconfig = data.map(item => [
                    item.venue_name,
                    item.income,
                    item.profit,
                    item.profit_margin,
                    item.add_time
                ]);
                this.centerConfig = {
                    header: ['中心', '收入', '利润', '利润率', '日期'],
                    headerBGC: "#000741",
                    oddRowBGC: "#122b5f",
                    evenRowBGC: "#000741",
                    data: dataconfig
                }
            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        // 外包损益分析
        outsourcingloss() {
            api.outsourcingloss({
                site_id: this.site_id,
                time: this.selectDate,
                type: this.selectDateType
            }).then(res => {
                let data = res.data;
                let dataconfig = data.map(item => [
                    item.venue_name,
                    item.company_name,
                    item.income,
                    item.profit,
                    item.profit_margin,
                    item.add_time
                ]);
                this.webConfig = {
                    header: ['中心', '外包商', '收入', '利润', '利润率', '日期'],
                    headerBGC: "#000741",
                    oddRowBGC: "#122b5f",
                    evenRowBGC: "#000741",
                    data: dataconfig
                }
            }).catch(err => {
                console.log('请求已取消:', err.message)
            })
        },
        async loadData() {
            this.$refs.pieChart.showLoading()

            try {
                // 模拟 API 请求
                await new Promise(resolve => setTimeout(resolve, 1000))

                // 更新柱状图数据
                this.barChartOptionsT.loading = false
                this.sycmOption.loading = false




                // 更新折线图数据
                // this.lineChartOptions.series[0].data = [120, 200, 150, 80, 70, 110, 130, 150, 180, 210, 240, 270]
                // this.lineChartOptions.series[1].data = [62, 82, 90, 89, 110, 105, 90, 104, 90, 103, 110, 120]
            } catch (error) {
                console.error('加载图表数据失败:', error)
            } finally {
                // 隐藏加载状态
                this.$refs.radarChart.hideLoading()
            }
        },
    },
}
</script>

<style lang="scss">
/* 全局重置 */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 科技感背景 */
.data-dashboard {
    width: 100vw;
    display: flex;
    flex-direction: column;
    height: 100vh;
    // background: #000c55;
    background: #000d4a url(../assets/bg.jpg) center top;
    // background: linear-gradient(135deg, #0a0e2a 0%, #0f173a 100%);
    color: #e6f7ff;
    font-family: 'Arial', sans-serif;
    overflow: hidden;
    position: relative;

    /* 背景装饰元素 */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background:
            radial-gradient(circle at 10% 20%, rgba(0, 170, 255, 0.1) 0%, transparent 20%),
            radial-gradient(circle at 90% 80%, rgba(0, 255, 200, 0.1) 0%, transparent 20%);
        z-index: -1;
    }
}

/* 头部样式 */
.dashboard-header {
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 40px;
    border-bottom: 1px solid rgba(0, 170, 255, 0.5);
    position: relative;

    h1 {
        font-size: 28px;
        background: linear-gradient(to right, #00aaff, #00ffff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: 0 0 10px rgba(0, 170, 255, 0.5);
    }

    .time {
        font-size: 18px;
        color: #00eeff;
        font-weight: bold;
        position: absolute;
        right: 1rem;
    }

    .p-left {
        position: absolute;
        left: 1rem;
    }
}

/* 主体区域 */
.dashboard-body {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: 3fr 4fr 3fr;
    height: calc(100vh - 80px);
    padding: 20px;
    gap: 20px;
}

/* 每列容器 */
.dashboard-column {
    display: grid;
    // grid-template-rows: repeat(5, 1fr);
    grid-template-rows: 1fr 1.5fr 1.5fr;
    gap: 15px;
}

/* 面板通用样式 */
.panel {
    // background: rgba(10, 20, 50, 0.7);
    border: 1px solid rgba(0, 170, 255, 0.5);
    // border-radius: 8px;
    padding: 15px;

    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;


    /* 面板内容区域 */
    .content {
        flex: 1;
        width: 100%;
        height: 100%;
        min-height: 0;
    }
}

.panel1 {
    // background: rgba(10, 20, 50, 0.7);
    border: 1px solid rgba(0, 170, 255, 0.5);
    // border-radius: 8px;
    padding: 15px;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;

    /* 面板内容区域 */
    .content {
        flex: 1;
        min-height: 0;
    }
}

.panel::before,
.panel::after {
    content: "";
    position: absolute;
    width: 16px;
    /* 角的长度 */
    height: 16px;
    /* 角的长度 */
    border-style: solid;
    border-color: #02a6b5;
    z-index: 1;
    /* 确保在内容之上 */
}

/* 左上角和右下角 */
.panel::before {
    top: 0;
    left: 0;
    border-width: 2px 0 0 2px;
    /* 上边框和左边框 */
}

/* 右上角和左下角 */
.panel::after {
    bottom: 0;
    right: 0;
    border-width: 0 2px 2px 0;
    /* 右边框和下边框 */
}

/* 特殊面板类型 */
.chart-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #4da8da;
}

.main-chart {
    grid-row: span 2;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    row-gap: 15px;
    // background: rgba(5, 15, 40, 0.8);
    font-size: 24px;
    color: #00ffff;
}

.main-chart-bottom {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    font-size: 24px;
    color: #00ffff;
}

.metric-card {
    // background: rgba(15, 30, 60, 0.7);
    color: #84d2ff;
}

.data-card {
    grid-row: span var(--row-span, 1);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 数字 */
.data-display {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: white;
    height: 100%;
}

.section {
    display: flex;
    align-items: center;
}

.label {
    font-size: 1.5rem;
    margin-right: .3rem;
}

.number-group {
    display: flex;
    gap: 0.5rem;
}

.digit {
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    background-color: #1a1a5f;
    border-radius: 0.3rem;
    box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.5);
    transition: transform 0.5s ease-in-out;
}

/* 动画效果 */
.animate {
    animation: flip 0.5s forwards;
}

// 标题样式

.title-box {
    width: 100%;
    height: 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 1rem;
    box-sizing: border-box;
}

.data-title {
    width: 8rem;
    height: 2.5rem;
    line-height: 2.375rem;
    // padding: 0.5rem 1rem;
    /* 上下内边距相当于 8px, 左右相当于 16px */
    background: linear-gradient(135deg, #005a9c, #007bff);
    border: 0.125rem solid #003d6f;
    border-radius: 0.25rem;
    /* 圆角半径相当于 4px */
    color: white;
    font-family: 'Microsoft YaHei', Arial, sans-serif;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.3),
        inset 0 0.0625rem 0.125rem rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
}

.check-more {
    font-size: .8rem;
    color: #84d2ff;
}

/* 数据容器样式 */
.data-container {
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   padding: 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    // background-color: #001f3f;
    border-radius: 8px;
    gap: .5rem;
    margin-top: .5rem;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    //   margin-bottom: 1rem;
}

/* 数据项样式 */
.data-item {
    flex: 1;
    text-align: center;
    // padding: 0.1rem;
    position: relative;
}

/* 标签样式 */
.label {
    font-family: 'Microsoft YaHei', Arial, sans-serif;
    font-size: 0.875rem;
    /* 相当于 14px */
    color: #ffffff;
    opacity: 0.8;
    margin-bottom: 0.25rem;
}

/* 值样式 */
.value {
    font-family: 'Microsoft YaHei', Arial, sans-serif;
    font-size: 1.5rem;
    /* 相当于 24px */
    font-weight: bold;
    color: #e6dd09;
    letter-spacing: 0.5px;
}

@keyframes flip {
    0% {
        transform: rotateX(0deg);
    }

    50% {
        transform: rotateX(90deg);
        opacity: 0;
    }

    100% {
        transform: rotateX(0deg);
        opacity: 1;
    }
}

/* 边框动画 */
@keyframes borderShine {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}

/* 响应式调整 */
// @media (max-width: 1600px) {
//     .dashboard-header {
//         height: 60px;
//         padding: 0 20px;

//         h1 {
//             font-size: 22px;
//         }

//         .time {
//             font-size: 16px;
//         }
//     }

//     .dashboard-body {
//         gap: 10px;
//         padding: 10px;
//     }

//     .panel {
//         padding: 10px;
//     }
// }</style>